import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const InnerWrapper = styled(Flex)`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 100vw;

  ${({ theme }) => css`
    margin: ${theme.spacing(4, 0)};
    gap: ${theme.spacing(4)};
  `}
`;

export const MyWatchesListWrapper = styled(Flex)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(6)};
    flex-direction: column;
    justify-content: center;
    ${theme.media.sm.up} {
      margin-bottom: ${theme.spacing(8)};
    }
  `}
`;
